import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, TextInput } from '@prisjakt/ui-inputs';
import { AppContext } from '@prisjakt/ui-app-context';

class PasswordInput extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.togglePassword = this.togglePassword.bind(this);
  }

  togglePassword() {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword,
    }));
  }

  render() {
    const { t } = this.context;
    const { showPassword } = this.state;
    return (
      <TextInput type={showPassword ? 'text' : 'password'} {...this.props}>
        <Checkbox
          name={`showPassword-${this.props.name}`}
          label={t('account', 'input.password-toggle')}
          checked={showPassword}
          onChange={this.togglePassword}
          tabIndex="0"
        />
      </TextInput>
    );
  }
}

PasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
};

PasswordInput.contextType = AppContext;

export default PasswordInput;
